<template>
  <div class="page-index user-info" style="width:500px">
    <el-form ref="info" :rules="rules" :model="form" label-width="150px">
      <el-form-item label="旧密码" prop="oldPwd">
        <el-input v-model="form.oldPwd" type="password" show-password autoComplete="on" placeholder="请输入旧密码"/>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
        <el-input v-model="form.newPwd" type="password" show-password autoComplete="on" placeholder="请输入新密码"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="footer-btn">
      <el-button type="primary" @click="handleChangePwd">确 定</el-button>
    </span>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiChangePwd, apiLogout } from '../../api/user'

  export default {
    mixins: [tableMixin],
    name: 'info',
    data() {
      return {
        form: {
          oldPwd: '',
          newPwd: ''
        },
        rules: {
          oldPwd: [
            { required: true, message: '旧密码不能为空', trigger: 'blur' },
            { max: 20, message: '长度在 20 个字符以内', trigger: 'blur' }
          ],
          newPwd: [
            { required: true, message: '新密码不能为空', trigger: 'blur' },
            { max: 20, message: '长度在 20 个字符以内', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {},
    activated() {
      if (this.$refs['info']) {
        this.$refs['info'].resetFields()
      }
    },
    methods: {
      // 修改密码
      handleChangePwd() {
        apiChangePwd(this.userInfo.id, this.form.oldPwd, this.form.newPwd).then(() => {
          this.$message({
            type: 'success',
            message: '修改密码成功'
          })
          apiLogout()
          window.sessionStorage.clear()
          this.$router.push({ name: 'login' })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.user-info
    .footer-btn
      display block
      position relative
      height 50px
      button
        position absolute
        top 0
        right 0
</style>
